export default __webpack_public_path__ + "static/media/HEIGHT WORK AND SLIP ACCIDENT SIMULATOR.73c080f9.JPG";